import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Card, CardBody, CardFooter } from "react-bootstrap";

import PageHeader from "../../../../core/common/crmComponents/PageHeader";
import { FaArrowRightArrowLeft } from "react-icons/fa6";
import { IOSSwitch } from "../../../../core/common/crmComponents/IOSSwitch";

const integrationsData = [
  {
    id: 1,
    name: "zoom",
    description: "Seamlessly integrate Zoom for meetings and webinars.",
    icon: "/assets/img/bsm/zoom-image.png",
    isEnabled: true,
  },
];

const Integrations = () => {
  const [integrations, setIntegrations] = React.useState(integrationsData);
  const navigate = useNavigate();

  // Handle toggle permission
  const handleToggle = (id) => {
    setIntegrations((prev) =>
      prev.map((integration) =>
        integration.id === id
          ? { ...integration, isEnabled: !integration.isEnabled }
          : integration
      )
    );
  };

  // Handle navigation to integration settings
  const handleConfigure = (name) => {
    navigate(`/crm/integrations/${name}`);
  };

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              {/* Page Header */}
              <PageHeader pageName="Integrations" />
            </div>
          </div>
          <div className="row">
            {integrations.map((integration) => (
              <div key={integration.id} className="col-md-4 mb-4">
                <Card className="shadow border-0 h-100 rounded-4">
                  <CardBody className="d-flex flex-column justify-content-start gap-3 pb-0">
                    {/* Icon */}
                    <div
                      className="me-3"
                      style={{
                        width: "100px",
                        height: "80px",
                        borderRadius: "8px",
                        overflow: "hidden",
                        border: "1px solid #ddd",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={integration.icon}
                        alt={integration.name}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                          transition: "transform 0.2s",
                          cursor: "pointer",
                        }}
                        onMouseOver={(e) =>
                          (e.target.style.transform = "scale(1.1)")
                        }
                        onMouseOut={(e) =>
                          (e.target.style.transform = "scale(1)")
                        }
                      />
                    </div>
                    {/* Details */}
                    <div>
                      <h5 className="fw-bold text-capitalize mb-1">
                        {integration.name}
                      </h5>
                      <p className="text-muted mb-2">
                        {integration.description}
                      </p>
                    </div>
                  </CardBody>
                  {/* Footer */}
                  <CardFooter className="d-flex justify-content-between align-items-center">
                    {/* Configure Button */}
                    <Button
                      variant="outline-primary"
                      onClick={() => handleConfigure(integration.name)}
                    >
                      <FaArrowRightArrowLeft />{" "}
                      <span className="ms-1">Configure</span>
                    </Button>
                    {/* iOS-style Toggle Button */}
                    <IOSSwitch
                      checked={integration.isEnabled}
                      onChange={() => handleToggle(integration.id)}
                    />
                  </CardFooter>
                </Card>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Integrations;
